module.exports = __webpack_public_path__ + "media/ejw/WrappedOrder-977c29fb.jpg";